export const fmtIDR = (n) =>
  new Intl.NumberFormat("id-ID", { style: "currency", currency: "IDR", maximumFractionDigits: 0 }).format(Number(n || 0));

export const fmtNum = (n, d = 2) =>
  new Intl.NumberFormat("id-ID", { minimumFractionDigits: d, maximumFractionDigits: d }).format(Number(n || 0));

export const fmtLiter = (n) => `${fmtNum(n)} L`;

export const FUEL_META = {
  pertalite: { name: "Pertalite", color: "emerald", ring: "ring-emerald-500", text: "text-emerald-600", bg: "bg-emerald-50", border: "border-emerald-200", dot: "bg-emerald-500" },
  dexlite: { name: "Dexlite", color: "lime", ring: "ring-lime-500", text: "text-lime-700", bg: "bg-lime-50", border: "border-lime-200", dot: "bg-lime-500" },
  pertamax: { name: "Pertamax", color: "blue", ring: "ring-blue-500", text: "text-blue-700", bg: "bg-blue-50", border: "border-blue-200", dot: "bg-blue-500" },
  pertamax_turbo: { name: "Pertamax Turbo", color: "rose", ring: "ring-rose-500", text: "text-rose-700", bg: "bg-rose-50", border: "border-rose-200", dot: "bg-rose-500" },
};

export const todayISO = () => new Date().toISOString().slice(0, 10);
